import { ScaleLoader } from "react-spinners";

const CustomLoader = () => {
  return (
    <div className="d-flex justify-content-center align-items-center h-100 w-100 ">
      <ScaleLoader
        color="#0C4DFF"
        loading={true}
        aria-label="Loading Spinner"
        data-testid="loader"
      />
    </div>
  );
};

export default CustomLoader;
